<template>
  <button :class="buttonClasses">
    <slot>
      <span>
        {{ buttonLabel ?? $texts('alva.activate', 'Alva aktivieren') }}
      </span>
      <AlvaLogoStill class="size-20" aria-hidden="true" />
    </slot>
  </button>
</template>

<script lang="ts" setup>
const props = defineProps<{
  consentBoxStyle: string
  buttonLabel?: string | undefined
}>()

// computed ref determines button class
const buttonClasses = computed(() => {
  // Base classes for the button.
  const classes: string[] = [
    'py-10',
    'px-15',
    'rounded-full',
    'flex',
    'items-center',
    'gap-10',
    'text-base',
    'transition-all',
    'ease-in-out',
    'duration-250',
  ]

  switch (props.consentBoxStyle) {
    case 'green':
    case 'unstyled':
    case 'hello':
      classes.push(
        'border-blue-900 bg-white bg-white hover:border-blue-900 hover:bg-blue-200 focus:shadow-purple-600 border text-blue-700 focus:outline-blue-900',
      )
      break
    case 'blue':
      //classes.push('bg-blue-900 hover:bg-blue-700 text-white')
      classes.push('button is-strong')
      break
  }

  return classes.join(' ')
})
</script>
